import React from 'react';
import Loader from '../UI/Loader/Loader';
import { Formik, Form } from 'formik';
import PrimaryModal from '../UI/Modal/PrimaryModal';
import { FormikInput, PrimaryButton } from "../UI";
import { useUserContext } from '../../contexts/UserContext';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const CreateOfferAndExperienceModal = ({ handleCloseModal, offerSuccessMessage, loading, handleSubmit, error, showCreateOfferModal, title="" }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

  return (
    <PrimaryModal title={title} hideModal={handleCloseModal}>
        <div className='p-6 space-y-6'>
            {loading && <Loader />}
            { offerSuccessMessage && <div>
                <p className='text-center'>{ offerSuccessMessage }</p>
            </div> }
            { !offerSuccessMessage && <div>
                {showCreateOfferModal.fields.includes(content.AEM_CONTENT_DETAILS.dropdown_btn.activate_at.id) && (
                    <p className="mb-4">The offer will be created in {userData.defaultWorkspace?.workspace_name} Workspace.</p>
                )}
                <Formik
                    initialValues={{
                        offer_name: '',
                        experience_name: ''
                    }}
                    onSubmit={(values) => handleSubmit(showCreateOfferModal.action, values)}
                >
                    {() => (
                        <Form className="space-y-4 md:space-y-6" action="#" id="target-form">
                            {showCreateOfferModal.fields.includes(content.AEM_CONTENT_DETAILS.dropdown_btn.activate_at.id) && (
                                <FormikInput
                                    type="text"
                                    id="offer_name"
                                    name="offer_name"
                                    label={content.AEM_CONTENT_DETAILS.input.offer_name}
                                />
                            )}
                            {showCreateOfferModal.fields.includes(content.AEM_CONTENT_DETAILS.dropdown_btn.save_experience.id) && (
                                <FormikInput
                                    type="text"
                                    id="experience_name"
                                    name="experience_name"
                                    label={content.AEM_CONTENT_DETAILS.input.exp_name}
                                />
                            )}
                            {error && <pre><p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error}</p></pre>}
                            <div className="flex items-center justify-end space-x-2">
                                <PrimaryButton type="submit">{content.AEM_CONTENT_DETAILS.submit_btn}</PrimaryButton>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div> }
        </div>
    </PrimaryModal>
  )
}

export default CreateOfferAndExperienceModal;